import Hero from "@/components/ui/Hero";
import ContactCard from "@/components/ui/ContactCard";
import ContactForm from "@/components/forms/ContactForm";
import OwnerPhoto from "@/components/ui/OwnerPhoto";
import { useDocumentTitle } from "@/hooks/useDocumentTitle";

export default function Contact() {
    useDocumentTitle(
        "Contact A1 Screening · Naples, FL · 239-434-7306",
        "Contact A1 Screening for pool cage and screen repair in Naples and Southwest Florida. Call 239-434-7306 or send a message."
    );
    return (
        <>
            <Hero
                eyebrow="Contact"
                title="Get In Touch"
                subtitle="Have a screen repair or rescreening question? Contact A1 Screening and your request will be reviewed by the team."
            />
            <section className="a1-section">
                <div className="a1-container grid md:grid-cols-2 gap-8">
                    <div className="grid gap-5" data-testid="contact-owner-column">
                        <ContactCard />
                        <div className="a1-card p-4 grid grid-cols-[120px_1fr] gap-4 items-center" data-testid="contact-owner-card">
                            <OwnerPhoto
                                variant="rounded"
                                aspectClass="aspect-square"
                                objectPositionClass="object-top"
                                showCaption={false}
                                testId="owner-photo-contact"
                            />
                            <div>
                                <p className="serif text-base font-bold m-0" style={{ color: "var(--color-text)" }}>
                                    John Stephens
                                </p>
                                <p className="text-[11px] uppercase tracking-[0.18em] font-bold m-0 mb-2" style={{ color: "var(--color-accent)" }}>
                                    Owner of A1 Screening
                                </p>
                                <p className="text-sm m-0" style={{ color: "var(--color-text-muted)" }}>
                                    Family-owned and serving Southwest Florida since 1999.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div>
                        <h2 className="mb-3">Send a Message</h2>
                        <ContactForm />
                    </div>
                </div>
            </section>
        </>
    );
}
